<template>
  <article class="dominance-line-container">
    <section class="dominance-line-chart-wrap">
      <div class="option-container">
        <p class="sub-title-1 text21 font__highlight flash-normal-ico">
          {{ $t("chart2.period") }}
        </p>
        <!-- <p class=" flash-normal-ico">Period</p> -->
        <div class="radio-list">
          <uiRadioBtn :items="radioOptions" @onChange="radioHandler" />
        </div>
      </div>
      <div
        class="chart-wrapper"
        v-for="(a, index) in dominanceList"
        :key="a.id"
      >
        <p class="title">
          {{ $t(a.label) }} {{ $t("menu-dropdown.dominance") }}
        </p>
        <!-- <div class="dominance-line-chart base-card"> -->
        <div
          :id="`${a.id}-line`"
          class="dominance-line-chart base-card"
          :ref="(el) => (chartContainers[index] = el)"
          style="position: relative"
        ></div>
        <!-- </div> -->
      </div>
    </section>
  </article>
</template>

<script setup>
import { createChart } from "lightweight-charts";
import { ref, onMounted, onUnmounted } from "vue";
import { getDominanceLine } from "@/api/chart/dominanceChartApi";
import { getCssVariableValue } from "@/utils/utils";
import uiRadioBtn from "@/components/ui/RadioBtn.vue";
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n({ useScope: "global" });
const radioOptions = [
  {
    id: "day2",
    key: "day2",
    value: `chart2.day`,
    period: { day: 2 },
    checked: false,
  },
  {
    id: "week1",
    key: "week1",
    value: "chart2.week",
    period: { week: 1 },
    checked: false,
  },
  {
    id: "week2",
    key: "week2",
    value: "chart2.week",
    period: { week: 2 },
    checked: false,
  },
  {
    id: "month1",
    key: "month1",
    value: "chart2.month",
    period: { month: 1 },
    checked: false,
  },
];

let selectedRadio = ref("");
let charts = [];
const chartContainers = ref([]);

const dominanceList = ref([
  { id: "btc", value: [], label: "chart2.bitcoinDominance" },
  { id: "tether", value: [], label: "chart2.tetherDominance" },
  { id: "fixed_kibot", value: [], label: "chart2.domi3" },
  { id: "variable_kibot", value: [], label: "chart2.domi4" },
]);

// const radioChange = async (id) => {
// charts.forEach((chart,index)=>{
//     console.log('chart',chart);
//     if(id == 'day2'){
//         chart.timeScale().setVisibleLogicalRange({from:dominanceList.value[index]['value'].length-25,to:dominanceList.value[index]['value'].length-1})
//     }else if(id == 'week1'){
//         chart.timeScale().setVisibleLogicalRange({from:dominanceList.value[index]['value'].length-169,to:dominanceList.value[index]['value'].length-1})
//     }else if(id == 'week2'){
//         chart.timeScale().setVisibleLogicalRange({from:dominanceList.value[index]['value'].length-336,to:dominanceList.value[index]['value'].length-1})
//     }else {
//         chart.timeScale().setVisibleLogicalRange({from:0,to:dominanceList.value[index]['value'].length-1})
//     }
// })
// }

const radioHandler = (res) => {
  const id = res.selected.key;
  // console.log("id", id);

  charts.forEach((chart, index) => {
    // console.log("chart", chart);
    if (id == "day2") {
      chart.timeScale().setVisibleLogicalRange({
        from: dominanceList.value[index]["value"].length - 25,
        to: dominanceList.value[index]["value"].length - 1,
      });
    } else if (id == "week1") {
      chart.timeScale().setVisibleLogicalRange({
        from: dominanceList.value[index]["value"].length - 169,
        to: dominanceList.value[index]["value"].length - 1,
      });
    } else if (id == "week2") {
      chart.timeScale().setVisibleLogicalRange({
        from: dominanceList.value[index]["value"].length - 336,
        to: dominanceList.value[index]["value"].length - 1,
      });
    } else {
      chart.timeScale().setVisibleLogicalRange({
        from: 0,
        to: dominanceList.value[index]["value"].length - 1,
      });
    }
  });
};

const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const chartOptions = {
  trackingMode: {
    exitMode: 1,
  },
  kineticScroll: {
    mouse: false,
  },
  autoSize: true,
  height: "100%",
  leftPriceScale: {
    borderVisible: false,
    visible: false,
  },
  overlayPriceScale: {
    position: "left",
    borderVisible: false,
    visible: false,
  },
  rightPriceScale: {
    visible: true,
    borderColor: "#505050",
    ticksVisible: true,
  },
  layout: {
    background: { color: "#010F1F" },
    textColor: getCssVariableValue("--chart-xy-font-color"),
  },
  grid: {
    vertLines: {
      color: "#021325",
    },
    horzLines: {
      color: "#454951",
      lineWidth: 1,
    },
  },
  timeScale: {
    barSpacing: 11,
    timeVisible: true,
    borderColor: "#454951",
    tickMarkFormatter(time) {
      var convertTime = new Date(time * 1000);
      let optionsT = {
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: localTimezone,
      };
      let localTime = convertTime
        .toLocaleString("en-US", optionsT)
        .replace(",", "");
      localTime = localTime.replace(/\//g, "-");
      return localTime;
    },
  },
  crosshair: {
    mode: 0,
  },
  localization: {
    timeFormatter(originalTime, timeZone) {
      const zonedDate = new Date(
        new Date(originalTime * 1000).toLocaleString("en-US", { timeZone })
      );
      const year = zonedDate.getFullYear();
      const month = (zonedDate.getMonth() + 1).toString().padStart(2, "0");
      const day = zonedDate.getDate().toString().padStart(2, "0");
      const hours = zonedDate.getHours().toString().padStart(2, "0");
      const minutes = zonedDate.getMinutes().toString().padStart(2, "0");
      let formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      return formattedDateTime;
    },
  },
};

const lineOptions = {
  lineWidth: 2,
  priceScaleId: "right",
  priceFormat: {
    type: "price",
    precision: 5,
    minMove: 0.00001,
  },
  color: getCssVariableValue("--chart-candle-down"),
  lastPriceValueVisible: false,
  priceLineVisible: false,
};
let lineSeries = {};
onMounted(async () => {
  dominanceList.value.forEach(async (dominance, index) => {
    const lineData = await getDominanceLine(dominance.id, index + 1);
    // console.log("lineData", lineData);
    const chart = createChart(chartContainers.value[index], chartOptions);
    lineSeries[dominance.id] = chart.addLineSeries(lineOptions);
    if (lineData[dominance.id] != undefined) {
      for (let i = 0; i < lineData[dominance.id].length; i++) {
        dominance.value.push({
          time: lineData[dominance.id][i]["time"],
          value: lineData[dominance.id][i]["value"],
        });
      }
      // console.log(dominance.value);
      lineSeries[dominance.id].setData(dominance.value);
      charts.push(chart);
      setTimeout(() => {
        chart.timeScale().fitContent();
      }, 1000);

      let container = chartContainers.value[index];
      let tooltipDiv = document.createElement("div");
      tooltipDiv.classList.add("tooltip-bg");
      tooltipDiv.style = `
              position: absolute;
              display: none;
              border-style: solid;
              white-space: nowrap;
              z-index: 9999999;
              box-shadow: rgba(0, 0, 0, 0.2) 1px 2px 10px;
              transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1), visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
              background-color: rgba(0, 0, 0, 0.4);
              border-width: 1px;
              border-radius: 4px;
              color: rgb(102, 102, 102);
              padding: 0px;
              border-color: rgb(0, 255, 239);
              backdrop-filter: blur(25px);
              pointer-events: none;
            `;
      container.appendChild(tooltipDiv);
      const updateLegend = async (param) => {
        if (
          param.point === undefined ||
          !param.time ||
          param.point.x < 0 ||
          param.point.x > container.clientWidth ||
          param.point.y < 0 ||
          param.point.y > container.clientHeight
        ) {
          tooltipDiv.style.display = "none";
          return;
        } else {
          tooltipDiv.style.display = "block";
          let bar = param.seriesData.get(lineSeries[dominance.id]);
          let value = bar.value;
          var formatPrice = (price) => price.toFixed(2);

          let timestampMs = bar.time * 1000;
          let ToDate = new Date(timestampMs);
          let options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            hour12: false,
            timeZone: localTimezone,
          };

          let timestampToString = ToDate.toLocaleString(
            "en-US",
            options
          ).replace(",", "");
          timestampToString = timestampToString.replace(/\//g, "-");
          timestampToString += ":00";
          setTooltipHtml(timestampToString, formatPrice(value), tooltipDiv);

          const y = param.point.y;
          let left = param.point.x + toolTipMargin;
          if (left > container.clientWidth - toolTipWidth) {
            left = param.point.x - toolTipMargin - toolTipWidth;
          }

          let top = y + toolTipMargin;
          if (top > container.clientHeight - toolTipHeight) {
            top = y - toolTipHeight - toolTipMargin;
          }
          tooltipDiv.style.left = left + "px";
          tooltipDiv.style.top = top + "px";
        }
      };
      chart.subscribeCrosshairMove(updateLegend);
    }
  });
});

onUnmounted(() => {
  console.log("unmounted");
  charts.forEach((chart) => chart.remove());
  charts = [];
});

let toolTipWidth = 100;
let toolTipHeight = 150;
let toolTipMargin = 15;

let setTooltipHtml = (time, value, tooltipDiv) => {
  tooltipDiv.innerHTML = `
  <div class="tooltip-wrap">
    <p class="time-wrap">${time}</p>
    <div class="gradient-line" style="margin-bottom:10px;"></div>
        <section class="formatter-section">
            <div class="formatter-wrapper">
                <p class="">${t(
                  "menu-dropdown.dominance"
                )} : <span class="error">${value}</span>%</p>
            </div>
        </section>
  </div>
  `;
};

// watch(()=> props.activeTab,(newVal)=> {
//   if(newVal == 'line'){
//     initTimeScale()
//   }
// })
// const initTimeScale = () => {
//   console.log('fit timescale');
//   setTimeout(()=> {
//     charts.forEach(chart => chart.timeScale().fitContent())
//   },1000)
// }
</script>

<style scoped lang="scss">
@import "@/assets/scss/components/charts/DominanceLine.scss";
.tooltip-bg {
  position: absolute;
  display: block;
  border-style: solid;
  white-space: nowrap;
  z-index: 9999999;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 2px 10px;
  transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  background-color: rgba(0, 0, 0, 0.4);
  border-width: 1px;
  border-radius: 4px;
  color: rgb(102, 102, 102);
  padding: 0px;
  border-color: rgb(0, 255, 239);
  backdrop-filter: blur(25px);
  pointer-events: none;
}
</style>
